module.exports = __webpack_public_path__ + "img/9cdf9f7.svg";